import React, { useState, useRef } from "react";
import { FlexBox } from "../containers";
import { ArrowDown } from "components/PopupMenu/styles";
import useOnClickOutside from "utils/hooks/useOnClickOutside";
import useHover from "utils/hooks/useHover";
import { StyledButton, PopupSelect, ContainerDiv } from "./styles";
import { TitleH14 } from "components/generic";

export interface IHowItWork {
  title: string;
  items: string[];
}

const HowItWork: React.FC<IHowItWork> = ({ title, items }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();

  useOnClickOutside(ref, () => !isHovered && setShow(false));

  return (
    <ContainerDiv>
      <StyledButton>
        <FlexBox onClick={() => setShow(!show)} ref={hoverRef}>
          <TitleH14>{title}</TitleH14>
          <ArrowDown size="2em" up={show} />
        </FlexBox>
        {show && (
          <PopupSelect className={show ? "panel active" : "panel"} ref={ref}>
            {items && items.map((item, i) => <p key={i}>{item}</p>)}
          </PopupSelect>
        )}
      </StyledButton>
    </ContainerDiv>
  );
};

export default HowItWork;
